<template>
	<AppModal v-bind="$attrs" :class="`modal--${product?.bg}`" class="product-modal">
		<div class="product-modal__content">
			<div class="product-modal__main">
				<div class="product-modal__image">
					<img :src="productImage?.url" :alt="$t(product?.name)" />
				</div>
			</div>

			<div class="product-modal__body">
				<h2 class="product-modal__title m-0 title">
					{{ $t(product?.name) }}
				</h2>

				<ul v-if="productLinks.length > 0" class="product-modal__list list-unstyled">
					<li
						v-for="(item, index) in productLinks"
						:key="index"
						class="product-modal__item"
					>
						<a
							:href="item.url"
							:target="item.target"
							class="product-modal__link btn btn--default"
						>
							{{ $t(item.title) }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</AppModal>
</template>

<script>
import AppModal from '@/components/landing/AppModal.vue'
import { getStoredRegion } from '@/helpers/defineRegion.js'

export default {
	name: 'CharacterModal',
	components: {
		AppModal
	},
	props: {
		product: {
			type: [Object, null],
			required: true
		}
	},
	data() {
		return {
			currentRegion: null
		}
	},
	computed: {
		productLinks() {
			return this.product?.links?.filter((link) => link.region.includes(this.currentRegion))
		},
		productImage() {
			return this.product?.images?.find((item) => item.region.includes(this.currentRegion))
		}
	},
	mounted() {
		this.currentRegion = getStoredRegion()
	}
}
</script>
